module.exports = __webpack_public_path__ + "img/emoji_10.e8ed956f.png";